const windowLocation = typeof window !== 'undefined' ? window.location : undefined;

export const IS_TESTING_ENVIRONMENT =
  // running the code locally
  process.env.NODE_ENV === 'development' ||
  // test pages
  !!windowLocation?.hostname?.startsWith?.('oneaudi-feature-app') ||
  // query parameter
  new URLSearchParams(windowLocation?.search).get('environment') === 'development' ||
  // on qa.audiusa.com only use staging ENV
  windowLocation?.hostname.includes('qa');

export const IS_STAGING_PAGE =
  windowLocation?.href.includes('staging') ||
  windowLocation?.hostname.includes('qa') ||
  process.env.NODE_ENV === 'development';

export const DEALER_SEARCH_API_GATEWAY_URL = IS_TESTING_ENVIRONMENT
  ? 'https://dev-dealer-graphql.apps.emea.vwapps.io/'
  : 'https://dealer-graphql.apps.emea.vwapps.io/';

export const AUDIUSA_API_GATEWAY_URL = IS_TESTING_ENVIRONMENT
  ? 'https://qa-api.audiusa.com/graphql'
  : 'https://api.audiusa.com/graphql';

export const IS_T3_WEBSITE = new URLSearchParams(windowLocation?.search).has('isdealer');
